/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrialStartdate } from './userTrialStartdate';
import type { UserTrialDurationDays } from './userTrialDurationDays';
import type { UserTrialMessage } from './userTrialMessage';
import type { UserTrialCtaLink } from './userTrialCtaLink';
import type { UserTrialCtaLabel } from './userTrialCtaLabel';

/**
 * Parameters for trial user accounts (output)
 */
export interface UserTrial {
  isTrial?: boolean;
  startdate?: UserTrialStartdate;
  durationDays?: UserTrialDurationDays;
  message?: UserTrialMessage;
  ctaLink?: UserTrialCtaLink;
  ctaLabel?: UserTrialCtaLabel;
  /** Check if trial is active */
  readonly trialActive: boolean;
}
